import axios from "axios";
import { URI_LOCAL } from "../data/constants";

export const getHomeInfo = () => {
    const response = axios.get(`${URI_LOCAL}HomeInfo/get_home_info`)
    return response
}

export const getScenarioByPlantId = (id:number) => {
    const response = axios.get(`${URI_LOCAL}HomeInfo/get_scenario_by_plant_id/${id}`)
    return response
}

export const getAllScenarios = () => {
    const response = axios.get(`${URI_LOCAL}HomeInfo/get_all_scenarios`)
    return response
}

export const changeCampaignYear = (body:any) => {
    const response = axios.put(`${URI_LOCAL}HomeInfo/change_campaign_year`, body)
    return response
}


export const testBackendDBConnectivity = () => {
    const response = axios.get(`${URI_LOCAL}HomePrueba/health_backend_connectivity`)
    return response
}

export const testEtlConnectivity = () => {
    const response = axios.get(`${URI_LOCAL}HomePrueba/health_etl`)
    return response
}

export const testFrontendConnectivity = () => {
    const response = axios.get(`${process.env.REACT_APP_BASE_REDIRECT}`)
    return response
}